import {
    createManualPayroll,
    getManualPayrollLoads,
    getPayrollLoads,
    getPayrolls,
    getPayrollSummary, voidPayroll,
} from './payroll.action';
export {payrollReducer} from './payroll.reducer';
export {watchPayroll} from './payroll.saga';

export const payrollActions = {

    /** Get Payrolls */
    getPayrolls,
    getPayrollSummary,
    getPayrollLoads,
    getManualPayrollLoads,
    createManualPayroll,
    voidPayroll,
    /** End */

}
